module.exports = new __parcel__URL__("exclamation-circle-amber.50406146.svg").toString();